import {findFirstFocusableElement} from 'shared/web';

/**
 * Focuses the first focusable element within the tab panel.
 * Uses requestAnimationFrame to ensure DOM updates are complete before focusing.
 */
export function focusFirstInputInTabPanel(): void {
  requestAnimationFrame(() => {
    // Find the visible tabpanel directly (Wizard has only one)
    const tabPanel = document.querySelector(
      '[role="tabpanel"]:not([hidden]):not([aria-hidden="true"])'
    ) as HTMLElement | null;

    if (!tabPanel) {
      return;
    }

    const firstInput = findFirstFocusableElement(tabPanel);
    if (firstInput) {
      try {
        firstInput.focus();
      } catch (error) {
        // Focus may fail if element becomes unavailable or is not focusable
        console.warn('Failed to focus first input in tab panel:', error);
      }
    }
  });
}
